import React from "react";

type SizeProps = {
  width?: string;
  height?: string;
  background?: boolean;
  backgroundColor?: string;
  color?: string;
  marginLeft?: any;
};

export default function DepositIcon(props: SizeProps) {
  const { width, height, background } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons-/-Full-/-Deposit">
          {background ? (
            <>
              <circle
                id="Oval"
                fill={props.backgroundColor ? props.backgroundColor : "#26626C"}
                cx="20"
                cy="20"
                r="20"
              ></circle>
              <g
                id="Group"
                transform="translate(10.000000, 6.000000)"
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeWidth="1.5"
              >
                <g id="Icons-/-Line-/-Deposit">
                  <path
                    d="M12.778,7.49992819 L18.889,7.49992819 C19.1816022,7.49705299 19.4633134,7.61082701 19.6718138,7.81613662 C19.8803142,8.02144624 19.9984186,8.30136902 20,8.59398101 L20,23.9059472 C19.9984186,24.1985592 19.8803142,24.478482 19.6718138,24.6837916 C19.4633134,24.8891012 19.1816022,25.0028752 18.889,25 L1.111,25 C0.818397762,25.0028752 0.536686634,24.8891012 0.328186193,24.6837916 C0.119685751,24.478482 0.00158141827,24.1985592 0,23.9059472 L0,8.59398101 C0.00158141827,8.30136902 0.119685751,8.02144624 0.328186193,7.81613662 C0.536686634,7.61082701 0.818397762,7.49705299 1.111,7.49992819 L7.222,7.49992819"
                    id="Path"
                  ></path>
                  <line
                    x1="10"
                    y1="0"
                    x2="10"
                    y2="13.9999691"
                    id="Path"
                    strokeLinejoin="round"
                  ></line>
                  <polyline
                    id="Path"
                    strokeLinejoin="round"
                    points="6.8 10.9999757 10 13.9999691 13.2 10.9999757"
                  ></polyline>
                </g>
              </g>
            </>
          ) : (
            <g
              id="Group"
              transform="translate(10.000000, 6.000000)"
              stroke={props.color ? props.color : "#000000"}
              strokeLinecap="round"
              strokeWidth="1.5"
            >
              <g id="Icons-/-Line-/-Deposit">
                <path
                  d="M12.778,7.49992819 L18.889,7.49992819 C19.1816022,7.49705299 19.4633134,7.61082701 19.6718138,7.81613662 C19.8803142,8.02144624 19.9984186,8.30136902 20,8.59398101 L20,23.9059472 C19.9984186,24.1985592 19.8803142,24.478482 19.6718138,24.6837916 C19.4633134,24.8891012 19.1816022,25.0028752 18.889,25 L1.111,25 C0.818397762,25.0028752 0.536686634,24.8891012 0.328186193,24.6837916 C0.119685751,24.478482 0.00158141827,24.1985592 0,23.9059472 L0,8.59398101 C0.00158141827,8.30136902 0.119685751,8.02144624 0.328186193,7.81613662 C0.536686634,7.61082701 0.818397762,7.49705299 1.111,7.49992819 L7.222,7.49992819"
                  id="Path"
                ></path>
                <line
                  x1="10"
                  y1="0"
                  x2="10"
                  y2="13.9999691"
                  id="Path"
                  strokeLinejoin="round"
                ></line>
                <polyline
                  id="Path"
                  strokeLinejoin="round"
                  points="6.8 10.9999757 10 13.9999691 13.2 10.9999757"
                ></polyline>
              </g>
            </g>
          )}
        </g>
      </g>
    </svg>
  );
}
